// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1678203014393
      var cssReload = require("C:/Users/Silvia/Local Sites/sito-matteo-botto/app/public/wp-content/themes/botto/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"publicPath":"./","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  